var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.calc.assumptions)?_c('p',{staticClass:"text-body-1 text--typography1"},[_vm._v(" This calculation has no assumptions. ")]):_c('ul',_vm._l((_vm.calc.assumptions),function(a,i){return _c('li',{key:i,staticClass:"mt-2 mb-2 text-wrap",domProps:{"innerHTML":_vm._s(_vm.makeAssumption(a))}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }